import React from 'react';

function CTA() {
  return (
    <section className="cta-section">
      <h2>Prêt à commencer votre voyage financier?</h2>
      <p>
        Rejoignez des centaines de Haïtiens qui construisent leur avenir financier
        ensemble à travers Haivest.
      </p>
      <button className="cta-button">Créer mon compte</button>
    </section>
  );
}

export default CTA;
